import React, { useEffect, useState } from "react";
import "./style.scss";
import Spinner from "../../../../reusableComponents/spinner/Spinner";
import { useNavigate } from "react-router-dom";
import { FormatUSD } from "../../../../utils/helpers/string";

function Commission({ afsPayoutList }) {
  const [totalAmount, setTotalAmount] = useState(afsPayoutList);
  useEffect(() => {
    setTotalAmount(afsPayoutList);
  }, [afsPayoutList]);
  const totalAmounts = totalAmount.reduce((acc, item) => acc + item.amount, 0);
  const navigate = useNavigate();
  return (
    <div className="commission ">
      <div className="commission-right box">
        <h2 className="component-heading">Your Current Reward is</h2>
        <p className="amount">{FormatUSD(totalAmounts)}</p>

        <button
          className="standard-button"
          onClick={() => navigate("/payout/afs-payouts")}
        >
          Claim
        </button>
      </div>
    </div>
  );
}

export default Commission;

const CustomInputBox = ({ formik }) => {
  const increment = () => {
    formik.setFieldValue(
      "percentage",
      Math.min(formik.values.percentage + 1, 15)
    );
  };

  const decrement = () => {
    formik.setFieldValue(
      "percentage",
      Math.max(formik.values.percentage - 1, 0)
    );
  };

  return (
    <>
      <div className="custom-input-box">
        <input type="text" value={`${formik.values.percentage}%`} readOnly />
        <div className="input-buttons">
          <span onClick={increment} style={{ cursor: "pointer" }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="20"
              viewBox="0 0 21 20"
              fill="none"
            >
              <line
                x1="10.1"
                y1="4.6"
                x2="10.1"
                y2="16.4"
                stroke="white"
                stroke-width="1.2"
                stroke-linecap="round"
              />
              <line
                x1="15.9"
                y1="10.6"
                x2="4.1"
                y2="10.6"
                stroke="white"
                stroke-width="1.2"
                stroke-linecap="round"
              />
            </svg>
          </span>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1"
            height="22"
            viewBox="0 0 1 22"
            fill="none"
          >
            <path
              d="M0.5 1L0.499999 21"
              stroke="white"
              stroke-opacity="0.2"
              stroke-linecap="round"
            />
          </svg>

          <span onClick={decrement} style={{ cursor: "pointer" }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="20"
              viewBox="0 0 21 20"
              fill="none"
            >
              <line
                x1="15.9"
                y1="10.6"
                x2="4.1"
                y2="10.6"
                stroke="white"
                stroke-width="1.2"
                stroke-linecap="round"
              />
            </svg>
          </span>
        </div>
      </div>
      {formik.touched.percentage && formik.errors.percentage && (
        <div className="form-error-message">{formik.errors.percentage}</div>
      )}
    </>
  );
};
